"use client";

import { CEREZ_OLAY } from "./CerezOnayi";

/**
 * Altbilgideki "Çerez tercihleri" bağlantısı — banner'ı yeniden açar.
 *
 * Ziyaretçinin kararını geri alabilmesi gerekir; onayı bir kez alıp bir daha
 * sormamak mevzuata uymaz. Altbilgi sunucu bileşeni olduğu için olay yayan
 * bu küçük istemci parçası ayrı duruyor.
 */
export function CerezTercihDugmesi() {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(CEREZ_OLAY))}
      className="text-left text-sm text-muted transition hover:text-foreground"
    >
      Çerez tercihleri
    </button>
  );
}
